export default {
  outStock: {
    search: {
      gmtCreate: '创建时间',
      createBy: '创建人',
      departmentName: '部门名',
      companyName: '公司名',
      orderNo: '订单号',
      orgName: '公司',
      outboundDepartment: '出库部门',
      outboundCompanyCode: '出库公司编码',
      outboundCompanyName: '出库公司',
      outboundDepartmentCode: '出库部门编码',
      outboundDepartmentName: '出库部门',
      projectCode: '项目代码',
      projectName: '项目名称',
      productCode: '产品编号',
      productName: '产品名称',
      outboundNo: '出库单号',
      productPriceWithTax: '销售含税单价',
      productUnit: '单位',
      customerName: '购货单位',
      salesAmount: '销售金额',
      deliveryDate: '发货日期',
      productCount: '实发数量',
      warehouseName: '仓库',
      productSpec: '规格型号',
      productBrand: '品牌',
      productType: '产品类别',
      otherInfo: '其他',
      productSpecAdjust: '校准型号',
      singleWeight: '单位净重',
      totalWeight: '总净重',
      batchNo: '批号',
      currencyName: '币种',
      processSerialNo: '加工流水号',
      afterSalesType: '售后类型',
      shipMode: '运输方式',
      outboundStatus: '状态',
      outboundType: '出库类型',
      remark: '备注',
      periodName: '账期',
    },
    label: {
      orderNo: '订单号',
      orgName: '公司',
      outboundDepartment: '出库部门',
      projectCode: '项目代码',
      projectName: '项目名称',
      productCode: '产品编号',
      productName: '产品名称',
      outboundNo: '出库单号',
      outboundCompanyCode: '出库公司编码',
      outboundCompanyName: '出库公司',
      outboundDepartmentCode: '出库部门编码',
      outboundDepartmentName: '出库部门',
      productPriceWithTax: '销售含税单价',
      productUnit: '单位',
      customerName: '购货单位',
      salesAmount: '销售金额',
      deliveryDate: '发货日期',
      productCount: '实发数量',
      warehouseName: '仓库',
      productSpec: '规格型号',
      productBrand: '品牌',
      productType: '产品类别',
      otherInfo: '其他',
      productSpecAdjust: '校准型号',
      singleWeight: '单位净重',
      totalWeight: '总净重',
      batchNo: '批号',
      currencyName: '币种',
      processSerialNo: '加工流水号',
      afterSalesType: '售后类型',
      shipMode: '运输方式',
      outboundStatus: '状态',
      outboundType: '出库类型',
      remark: '备注',
      periodName: '账期',
    },
    form: {
      basicDetailInfo: '基本信息',
      basicDetailPct: '配方行项目',
      salesSpecification: '销售规格',
      constructionSpecification: '施工规格',
      costingCost: '成本计算',
      importType: '选择出库类型导入',
    },
    table: {
      sortNo: '行项目号',
      productName: '销售商品',
      materialDesc: '配料描述',
      formulaCategory: '大类',
      figureType: '花纹',
      formulaNo: '配方编号',
      productCode: '商品编码',
      productModel: '规格型号',
      basicUnit: '基本单位',
      weight: '重量',
      selectPlaceholder: '请选择',
      productCount: '数量',
      gmtCreate: '添加日期',
      processCost: '价格',
    },
    buttons: {
      error: 'Operation failed!',
      confirm: 'Confirm',
      save: '保存',
      submit: '提交',
      upload: '上传附件',
      add: '增加',
      delete: '删除',
    },
    message: {
      noData: '您还未选择任何数据',
      pleaseSelectOne: '请选择一条数据操作',
      topFormCheckResult: '请您将数据填写完整',
      deleteSuccess: '删除成功',
      baseDataIncomplete: '请将基本数据填写完整',
      salesDataIncomplete: '请将销售数据填写完整',
      purchasingDataIncomplete: '请将采购数据填写完整',
      is_expand_apply: '数据已存在，是否扩展申请',
      return_list_page: '返回合作伙伴主数据页面',
      data_repeat: '已存在该数据',
      cancelled: '已取消',
      canNotChange: '该数据状态不可编辑',
      enable_to_forbid: '启用只针对已禁用的状态',
      forbid_to_enable: '禁用只针对已生效的状态',
      merge_need_enable: '合并功能针对已生效的数据',
      saveSuccess: '保存成功',
      noSelectError: '请选择一个类型导入',
    },
    placeholder: {
      productClass: '商品/原料',
      productCode: '产品编号',
      productName: '产品名称',
      productType: '主料/辅料',
      productCategory: '产品类别',
      productConfirmName: '校准名称',
      productStatus: '数据状态',
      projectCode: '项目编号',
      projectName: '项目名称',
      costType: '成本类型',
      companyCode: '公司编号',
      companyName: '公司名',
      confimProductNameSpec: '校准名称（型号）',
      departmentName: '部门名',
      gmtCreate: '创建时间',
      createBy: '创建人',
      productSpec: '规格型号',
    },
    options: {
      domesticTrade: '内贸',
      generalTrade: '一般贸易',
      feedProcessing: '进料加工',
    },
  },
};
